import React from 'react';
import DeliverySelection from './delivery-selection';
import CustomerAddress from './customer-address';

const DeliverySection = ({
  deliveryOptions,
  selectedDeliveryOptions,
  handleDeliveryOptions,
  products,
}) => {
  const handleChangeDeliveryOptions = (option) => {
    handleDeliveryOptions(option);
  };

  const isMoreOptions = deliveryOptions.length >= 4

  return (
    <div className={`d-flex ${isMoreOptions ? 'flex-wrap mb-2' : 'h-100'}`}>
      <div className="d-lg-block d-none w-100 pt-3">
        <CustomerAddress isSingleOption={deliveryOptions.length <= 1} />
      </div>
      <DeliverySelection
        changeDeliveryOptions={handleChangeDeliveryOptions}
        deliveryOptions={deliveryOptions}
        selectedDeliveryOptions={selectedDeliveryOptions}
        products={products}
        isMoreOptions={isMoreOptions}
      />
    </div>
  );
};

export default DeliverySection;
